import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { User, Role } from 'src/app/_models';
import { AuthenticationService, UserService } from 'src/app/_services';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2/dist/sweetalert2.js'

@Component({
  selector: 'app-user-core-header',
  templateUrl: './user-core-header.component.html',
  styleUrls: ['./user-core-header.component.scss']
})
export class UserCoreHeaderComponent implements OnInit {
  showFiller = false;
  linkActive: string;
  linkSelected: any;
  e:string;
  lng: any;
  show = false ;
  currentUser: User;
  loading = false;
  userConnecte = JSON.parse(localStorage.getItem('currentUser')).username
  companyconnecteCondition = JSON.parse(localStorage.getItem('currentAdmin'))
  userFromApi: User;
  UrlIcon: string;
  IconUserConnected: any;
  constructor(private router: Router,private authenticationService: AuthenticationService , private userService: UserService,private http: HttpClient,
    private titleService:Title) {
      this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
         this.currentUser = this.authenticationService.currentUserValue;
    }

  ngOnInit(): void {
    this.UrlIcon =localStorage.getItem('icon')
    this.userFromApi = JSON.parse(localStorage.getItem('currentUser'))
    this.IconUserConnected= JSON.parse(localStorage.getItem('currentUser'))?.reseller_logo
    //console.log( JSON.parse(localStorage.getItem('currentUser')))
    this.userService.getById().pipe(first()).subscribe(user => {
      this.loading = false;
    //  this.userFromApi = user;

      //console.log(user)

      //console.log(user.status)
      if (user.status== "Token is Expired") {
       this.logout()
      }

  });

    this.lng =  localStorage.getItem('langue')


    this.linkSelected = localStorage.getItem("link")
    //console.log(this.linkSelected)
    //this.RedirectGo(this.e);
    this.loading = true;



  }



  RedirectGo(e){
    //  this.router.navigate([e]);
      this.linkActive =e

      localStorage.setItem('link', this.linkActive);


    }

  get isUser() {
    return this.currentUser && this.currentUser.role === Role.User;
}

  logout() {
    // this.http.post('http://192.168.1.98:8000/api/logout',{}).subscribe(data => {
    //   //console.log(data)

    // })
    this.authenticationService.logout();
  //   document.getElementById('favicon').setAttribute('href', 'https://app.stgdrive.com/assets/1.16:85/ctx/images/custom/stg/favicon.ico');
  //   this.titleService.setTitle("STG DRIVE");
  // window.location.href= '/login'

}

redirectAdmin(){


  window.location.href="admin/companypartner"

}

connectUser(){

  const headerDict = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Headers': 'Content-Type',
  }

  const requestOptions = {
    headers: new HttpHeaders(headerDict),
  };
localStorage.setItem('company' ,JSON.parse(localStorage.getItem('currentUser')).company)
localStorage.setItem('idCompany' ,JSON.parse(localStorage.getItem('currentUser')).company_id)
localStorage.setItem('reseller' ,JSON.parse(localStorage.getItem('currentUser')).reseller)
  this.http.get(environment.apiUrl+'/users/loginAs/'+JSON.parse(localStorage.getItem('currentAdmin')).id,requestOptions).subscribe((user)=>{
    var userObject:any =user
    localStorage.setItem('currentUser', JSON.stringify(userObject.message));

    //console.log(user)



    Swal.fire({
      title: 'Connecté succès',
      text: "Vous êtes maintenant connecté en tant que "+JSON.parse(localStorage.getItem('currentUser')).firstName,
      icon: 'success',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href="admin/companyuser/"+localStorage.getItem('reseller')+'/'+localStorage.getItem('company')+'/'+localStorage.getItem('idCompany')
        localStorage.removeItem('company')
        localStorage.removeItem('idCompany')
        localStorage.removeItem('icon')
        localStorage.removeItem('reseller')
      }
    })

//location.reload()

   })

}
showDiv(){
  this.show = !this.show;
}
}
